import { toState } from "../base/redux/functions";
/**
 * Validates a tegoJitsiServer config object:
 *   - must exist
 *   - must be enabled
 *   - must have valid http(s) URLs for tego & odonto
 *
 * @param config – any object that may contain tegoJitsiServer
 * @returns ConfigValidationResult
 */
export function validateTegoJitsiServerConfig(config) {
    if (!config?.tegoJitsiServer) {
        return { success: false, error: "Tego Jitsi Server no configurado." };
    }
    const { urls, enabled } = config.tegoJitsiServer;
    if (!enabled || !urls) {
        return { success: false, error: "Característica mal configurada." };
    }
    const { tego: tegoStrUrl, odonto: odontoStrUrl, ui: uiStrUrl } = urls;
    if (!tegoStrUrl || !odontoStrUrl || !uiStrUrl) {
        return { success: false, error: "Faltan URLs en la configuración." };
    }
    let tego, odonto, ui;
    try {
        tego = new URL(tegoStrUrl);
    }
    catch {
        return { success: false, error: "URL inválida en configuración (tego)." };
    }
    try {
        odonto = new URL(odontoStrUrl);
    }
    catch {
        return { success: false, error: "URL inválida en configuración (odonto)." };
    }
    try {
        ui = new URL(uiStrUrl);
    }
    catch {
        return { success: false, error: "URL inválida en configuración (ui)." };
    }
    for (const [name, url] of [
        ["tego", tego],
        ["odonto", odonto],
        ["ui", ui],
    ]) {
        if (!["http:", "https:"].includes(url.protocol)) {
            return {
                success: false,
                error: `Protocolo no soportado en ${name} (solo http/https).`,
            };
        }
    }
    return { success: true, urls: { tego, odonto, ui } };
}
export function getIsEnabled(stateful) {
    const tegoServer = toState(stateful)['features/tego-server'];
    return tegoServer.isEnabled;
}
